import {
    SpacingToken,
    UiStack,
} from '@experiences/ui-common';
import { Box } from '@mui/material';
import {
    ApIcon,
    PortalCustomIcon,
} from '@uipath/portal-shell-react';
import React, {
    useCallback,
    useState,
} from 'react';

import type { StepComponentProps } from '../../constants';
import {
    GovernancePolicyCreateStepCard,
    type StepCardProps,
} from '../../subcomponent/GovernancePolicyCreateStepCard';

const cardData: StepCardProps[] = [
    {
        label: 'CLIENT_GOVERNANCE_START_MANUAL_LABEL',
        title: 'CLIENT_GOVERNANCE_START_MANUAL_TITLE',
        description: 'CLIENT_GOVERNANCE_START_MANUAL_DESCRIPTION',
        icon: <ApIcon
            name='verified_user'
            size='35px'
            variant='outlined' />,
        status: 'default',
    },
    {
        label: 'CLIENT_GOVERNANCE_START_TEMPLATE_LABEL',
        title: 'CLIENT_GOVERNANCE_START_TEMPLATE_TITLE',
        description: 'CLIENT_GOVERNANCE_START_TEMPLATE_DESCRIPTION',
        icon: <PortalCustomIcon
            name='template'
            size='35px'
        />,
        status: 'info',
    },
    {
        label: 'CLIENT_GOVERNANCE_START_AUTOPILOT_LABEL',
        title: 'CLIENT_GOVERNANCE_START_AUTOPILOT_TITLE',
        description: 'CLIENT_GOVERNANCE_START_AUTOPILOT_DESCRIPTION',
        icon: <PortalCustomIcon
            name='autopilot_color'
            size='35px'
        />,
        status: 'success',
    },
];

export const GovernancePolicyCreateStartStep: React.FC<StepComponentProps> = ({ onNext }) => {
    const [ selectedOption, setSelectedOption ] = useState<string | null>(null);

    const handleCardClick = useCallback((option: string) => {
        setSelectedOption(option);
        onNext({ selectedOption: option });
    }, [ onNext ]);

    return (
        <UiStack
            direction="column"
            justify='between'
            data-cy='governance-policy-create-start-step'
            h='100%'>
            <UiStack
                direction="column"
                justify='between'
                gap={SpacingToken.M}>
                <UiStack
                    direction="row"
                    gap={SpacingToken.M}
                >
                    <Box sx={{ flex: '1 1 0' }}>
                        <GovernancePolicyCreateStepCard
                            {...cardData[0]}
                            isSelected={selectedOption === 'manual'}
                            onClick={() => handleCardClick('manual')}
                            height="170px"
                            dataCy="governance-policy-create-start-step-manual"
                        />
                    </Box>
                    <Box sx={{ flex: '1 1 0' }}>
                        <GovernancePolicyCreateStepCard
                            {...cardData[1]}
                            isSelected={selectedOption === 'template'}
                            onClick={() => handleCardClick('template')}
                            height="170px"
                            dataCy="governance-policy-create-start-step-template"
                        />
                    </Box>
                </UiStack>
                <Box sx={{ width: '100%' }}>
                    <GovernancePolicyCreateStepCard
                        {...cardData[2]}
                        isSelected={selectedOption === 'autopilot'}
                        onClick={() => handleCardClick('autopilot')}
                        height="154px"
                        dataCy="governance-policy-create-start-step-autopilot"
                    />
                </Box>
            </UiStack>
        </UiStack>
    );
};
